import React, { useCallback, useEffect, useState } from 'react';
import SelectDropdown from 'components/base/select-dropdown';
import CurrencyInput from 'components/base/currency-input';
import { ReactComponent as CloseIcon } from 'assets/icons/close-line.svg';
import useBrandChefsContext from 'contexts/brand-chefs.context';
import { IngredientType } from 'models/pricing.model';
import { ENUM_UNIT } from 'models/common.model';
import {
  Dropdown,
  DropdownItem,
  DropdownList,
  Input,
  ToastMessage
} from '@cokitchen/cokitchen-components';
import { ArrowDownIcon, DeleteIcon } from 'cokitchen-icons';
import { weightMeasurement } from 'utils/constants';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { debounce } from 'utils/functions';

const AddConversionListStoreItems = () => {
  const {
    conversionListFormData,
    setConversionListFormData,
    selectedConversionItem,
    setSelectedConversionItem
  } = useBrandChefsContext();

  const [ingredients, setIngredients] = useState([]);

  const [search, setSearch] = useState('');

  const fetchIngredients = async (searchString: string) => {
    try {
      const response = await apiService.get(`ingredients`, {
        params: { name: searchString, page: 1 }
      });
      if (response) {
        setIngredients(response?.data?.results);
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error fetching vendors'}
          type='error'
        />
      );
    } finally {
      // setSearch('');
    }
  };

  const debounceFetchIngredients = useCallback(debounce(fetchIngredients, 500), []);

  useEffect(() => {
    debounceFetchIngredients(search);
  }, [search]);
  const addItems = () => {
    const newVendors = [...conversionListFormData];
    const newVendor = selectedConversionItem;
    if (!newVendor) return;
    newVendor.ingredients = [
      ...newVendor.ingredients,
      { name: '', quantity: '', type: ENUM_UNIT.KG }
    ];
    setSelectedConversionItem(newVendor);
    setConversionListFormData(newVendors);
  };

  const removeConversionItem = (index: number) => {
    if (conversionListFormData.length < 2) {
      return;
    }
    setConversionListFormData(conversionListFormData.filter((item, i) => index !== i));
  };
  const removeItems = (itemIndex: number) => {
    const newVendors = [...conversionListFormData];
    const newVendor = selectedConversionItem;

    if (!newVendor || newVendor?.ingredients?.length < 2) return;
    newVendor.ingredients = newVendor.ingredients.filter((_, idx) => idx !== itemIndex);
    setSelectedConversionItem(newVendor);
    setConversionListFormData(newVendors);
  };

  const handleInputChange = (
    itemIndex: number,
    value: string | number | ENUM_UNIT,
    name: keyof IngredientType
  ) => {
    let newVendors = [...conversionListFormData];
    const newVendor = selectedConversionItem;
    if (!newVendor) return;
    const newItems = newVendor?.ingredients.map((b) => ({ ...b }));
    newItems[itemIndex][name] = value as any;
    newVendor.ingredients = newItems;
    newVendors = newVendors.map((_, i) => (i === newVendor.itemIndex ? newVendor : _));
    setSelectedConversionItem(newVendor);
    setConversionListFormData(newVendors);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement> | { target: { name: string; value: string } },
    index: number
  ) => {
    const { name, value } = e.target;
    setConversionListFormData(
      conversionListFormData.map((itm, i) => (i === index ? { ...itm, [name]: value } : itm))
    );
    if (selectedConversionItem)
      setSelectedConversionItem({
        ...selectedConversionItem,
        [name]: value
      });
  };

  return selectedConversionItem ? (
    <div>
      <div className='flex justify-start items-center gap-2 overflow-y-hidden overflow-x-auto w-full mb-10'>
        {conversionListFormData.map((item, itemIndex) => {
          const isSelected = selectedConversionItem.itemIndex === itemIndex;
          return (
            <div
              onClick={() => {
                setSelectedConversionItem({ ...item, itemIndex });
              }}
              className={`flex justify-between items-center gap-2 p-2 cursor-pointer min-w-[200px] max-w-[200px] ease-in-out duration-300 transition-colors border-b-2 ${
                isSelected ? 'bg-[#FEF0F2] border-[#E60A2B]' : 'border-transparent'
              }`}
              key={itemIndex}>
              <div className='flex flex-col justify-start items-start gap-2'>
                <span className='font-semibold'>{item.name}</span>
                <span className='text-gray-9 text-sm'>{item.secton_name}</span>
              </div>

              <span
                onClick={(e) => {
                  e.stopPropagation();
                  removeConversionItem(itemIndex);
                }}
                className='min-w-[20px] min-h-[20px] max-w-[20px] max-h-[20px] flex justify-center items-center rounded-full hover:bg-[#FEDDE2] ease-in-out duration-300 transition-colors cursor-pointer'>
                <CloseIcon width={30} />
              </span>
            </div>
          );
        })}
      </div>

      <div className='flex justify-start items-center gap-4'>
        <span className='font-semibold'>Number of portions</span>

        <div className='w-full md:w-[250px] relative'>
          <Input
            design='bordered'
            placeholder='number of portions'
            name='no_of_portions'
            value={selectedConversionItem.no_of_portions}
            onChange={(e) => handleChange(e, selectedConversionItem.itemIndex)}
          />
          <div className='absolute w-[50px] h-[20px] z-10 rounded-[2px] shadow bottom-[20%] right-[5%]'>
            <Dropdown
              hideOnClick
              content={
                <div className='h-5 p-1 text-[11px] flex justify-between items-center gap-[2px] cursor-pointer measurement_dropdown'>
                  <span className='text-[#6F7376] truncate'>
                    {selectedConversionItem.portion_type}
                  </span>
                  <ArrowDownIcon className='w-5 h-5 text-[#96999C]' />
                </div>
              }>
              <DropdownList>
                {weightMeasurement.map((item) => (
                  <DropdownItem
                    key={item.value}
                    onClick={() => {
                      handleChange(
                        { target: { name: 'portion_type', value: item.value } },
                        selectedConversionItem.itemIndex
                      );
                    }}>
                    {item.name}
                  </DropdownItem>
                ))}
              </DropdownList>
            </Dropdown>
          </div>
        </div>
      </div>

      {selectedConversionItem?.ingredients.map(({ ingredient_name, quantity, type }, itemIndex) => {
        return (
          <div key={itemIndex}>
            <div className='flex justify-between items-center gap-6 w-[100%] mt-4'>
              <SelectDropdown
                hasSearch
                label='Item name'
                placeholder='Search item'
                value={ingredient_name}
                setValue={(item) => handleInputChange(itemIndex, item.name, 'name')}
                onChange={(val) => {
                  setSearch(val);
                }}
                options={ingredients}
              />
              <CurrencyInput
                name='quantity'
                label='Quantity'
                placeholder=' 2,000'
                hasUnit
                value={quantity}
                unitValue={type}
                disableUnit
                onUnitChange={(value) => handleInputChange(itemIndex, value, 'type')}
                decimalsLimit={2}
                onChange={(value) => handleInputChange(itemIndex, value, 'quantity')}
              />
              <div className='flex justify-end'>
                {
                  <button
                    onClick={() => removeItems(itemIndex)}
                    className='min-w-[30px] min-h-[30px] max-w-[30px] max-h-[30px] flex justify-center items-center rounded-full hover:bg-[#FEDDE2] ease-in-out duration-300 transition-colors cursor-pointer text-[#E60A2B] '>
                    <DeleteIcon />
                  </button>
                }
              </div>
            </div>

            <button onClick={() => addItems()} className='text-[#0080E5] font-medium text-sm mt-1'>
              + Add Ingredient
            </button>
          </div>
        );
      })}
    </div>
  ) : null;
};

export default AddConversionListStoreItems;
